import { Component, Inject, Input, OnInit } from '@angular/core';
import { AccionAnualModel } from 'src/app/model/FaseAnual.model';
import { FaseAnualComponent } from '../fase-anual.component';

@Component({
  selector: 'app-accion-anual',
  templateUrl: './accion-anual.component.html',
  styleUrls: ['./accion-anual.component.css']
})

export class AccionAnualComponent implements OnInit {

  @Input() accionData : AccionAnualModel;
  @Input() readonly : boolean;
  fechaValida : boolean = false;
  fechaClass : string = "input-fecha";
  startDate: Date;
  fechaInicio : any;
  fechaFin : any;

  constructor(
    @Inject(FaseAnualComponent) private parent: FaseAnualComponent,
  ) { }

  ngOnInit(): void {
    this.cargaInicial()
  }

  cargaInicial(){
    var fechaInicioMedicion =  this.accionData.fechaInicioMedicion ? new Date(this.accionData.fechaInicioMedicion) : null;
    var fechaFinMedicion =  this.accionData.fechaFinMedicion ? new Date(this.accionData.fechaFinMedicion) : null;
    if (fechaFinMedicion != null && fechaInicioMedicion != null) {
      
      this.fechaInicio  = {"day": fechaInicioMedicion.getDate(), "month": fechaInicioMedicion.getMonth() + 1, "year": fechaInicioMedicion.getFullYear()};

      this.fechaFin  = {"year": fechaFinMedicion.getFullYear(),"month": fechaFinMedicion.getMonth() + 1, "day": fechaFinMedicion.getDate()};
      this.validarFechas();
    }
  }

  change(){
    this.parent.cambios = true;
    this.validarFechas();
  }

  clearDateInicio(){
    this.accionData.fechaInicioMedicion = null;
    this.fechaInicio = "";
  }

  clearDateFin(){
    this.accionData.fechaFinMedicion = null;
    this.fechaFin = "";
  }

  validarFechas(){
    this.fechaClass = "input-fecha-error";
    this.fechaValida = false;
    if( this.fechaInicio != undefined && this.fechaFin != undefined  && this.fechaInicio != null && this.fechaFin != null){

      var fechaInicioMedicion = new Date(this.fechaInicio.year, this.fechaInicio.month -1, this.fechaInicio.day);
      var fechaFinMedicion = new Date(this.fechaFin.year, this.fechaFin.month -1 , this.fechaFin.day);

      this.accionData.fechaInicioMedicion = fechaInicioMedicion;
      this.accionData.fechaFinMedicion = fechaFinMedicion;

      if (fechaFinMedicion.getTime() - fechaInicioMedicion.getTime() >= 86400000) {
        this.fechaValida = true;
        this.fechaClass = "input-fecha";
      } else {
        this.fechaClass = "input-fecha-error";
        this.fechaValida = false;
      }

    } else {
      this.fechaClass =  "input-fecha-error";
      this.fechaValida = false;
    }
    this.parent.fechaValida = this.fechaValida;
  }
}